import React from 'react';
import styles from './EArchiveGroupActionsWrapper.module.scss';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import { GroupActionItem } from '../../../Interfaces/GroupActionItem.interface';

interface Props {
	items: GroupActionItem[];
}

const EArchiveGroupActionsWrapper = ({ items }: Props) => {
	return (
		<div className={styles.wrapper}>
			{items.map(item => (
				<LinkButton
					key={item.title}
					title={item.title}
					onClick={item.onClick}
					theme={Theme.BLUE}
				/>
			))}
		</div>
	);
};

export default EArchiveGroupActionsWrapper;
